import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { Constantes } from "src/app/shared/constantes";
import { SigtUtilisateurService } from "src/app/shared/services/sigt-utilisateur.service";
import { ZzzSecuriteService } from "src/app/zzz/securite/shared/securite.service";
import { MesInformationsComponent } from "../../utilisateurs/mes-informations/mes-informations.component";
import { BienvenueSansAccesComponent } from "./bienvenue-sans-acces/bienvenue-sans-acces.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import { AccueilNonAuthentifieComponent } from "./accueil-non-authentifie/accueil-non-authentifie.component";
import { RouterModule } from "@angular/router";
import { PivPiedPageComponent } from "src/app/zzz/ui/piv-pied-page/piv-pied-page.component";
import { DocumentService } from "src/app/shared/services/document.service";

@Component({
    selector: 'app-accueil-pes',
    templateUrl: './accueil-pes.component.html',
    styleUrls: ['./accueil-pes.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MesInformationsComponent,
        BienvenueSansAccesComponent,
        AccueilNonAuthentifieComponent,
        PivPiedPageComponent
    ]
})
export class AccueilPesComponent {
  #utilisateurService = inject(SigtUtilisateurService);
  #authService = inject(ZzzSecuriteService);

  estAuthentifie = this.#authService.utilisateurEstAuthentifie;
  utilisateur = this.#utilisateurService.current;
  constructor(
    private documentService: DocumentService
  ) { }

  @ViewChild('descPublic', { static: false }) paragraphDesc!: ElementRef<HTMLParagraphElement>;

  ngAfterViewInit() {
    this.paragraphDesc?.nativeElement?.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (target.closest('a.guideLink')) {
        e.preventDefault();
        this.openDocument('guide_Utilisateur_PGTP_Publique', e as MouseEvent);
      }
    });
  }

  get estInterne(): boolean {
    return this.estAuthentifie ? this.utilisateur.type === Constantes.TypeUtilisateur.Interne : false;
  }

  get estAvecRoleParDefaut(): boolean {
    return this.estAuthentifie ? this.#authService.hasRole(Constantes.Roles.RU_ACCES_INTRA_SIG) : false;
  }

  openDocument(fileName: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.documentService.getPdf(fileName).subscribe({
        next: blob => {
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 30000);
        },
        error: err => {
          console.error("Erreur inattendue", err);
        }
    });
  }
}
